import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType } from '../../constants';

export class GaTrackingSearch_0_results_clickEventModel implements GATrackingEvent {
  constructor(private payload: { action: GATrackingEventType; element: string }) {}

  getEventActionFromPage(): any {
    return `${this.payload.action} clicked`;
  }

  getEventType(): GATrackingEventType {
    return this.getEventActionFromPage();
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: 'search_0_results_click',
      label: this.payload.element,
    };
  }
}
